import { render, staticRenderFns } from "./foldable.vue?vue&type=template&id=2d162548"
import script from "./foldable.vue?vue&type=script&lang=js"
export * from "./foldable.vue?vue&type=script&lang=js"
import style0 from "./foldable.vue?vue&type=style&index=0&id=2d162548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports